import { GETTEXT_ALL_FACILITIES } from '@/shared/lib';
import { create } from 'zustand';
import fetchPhysiciansService from '../api/services/fetchPhysicians';
import type { PhysicianState } from './store.types';

export const defaultPhysicianState = {
  physicians: [] as any[],
};

// Thay cho takeLatest của saga cũ: bỏ kết quả của request đã bị một request mới hơn vượt qua.
let requestId = 0;

/**
 * Zustand store holding the physician list used by facility-scoped physician pickers. Its fetchPhysicians action queries physicians for a facility (omitting the filter for the all-facilities sentinel), logs and swallows failures, and discards responses from superseded calls by comparing a monotonic requestId before writing state.
 *
 * @returns The physician store hook.
 */
const usePhysicianStore = create<PhysicianState>()((set) => ({
  ...defaultPhysicianState,
  fetchPhysicians: async (facilityId) => {
    requestId += 1;
    const current = requestId;
    let physicians: any[] = [];
    try {
      const queryFilter = facilityId !== GETTEXT_ALL_FACILITIES ? { facilityId } : undefined;
      physicians = await fetchPhysiciansService(queryFilter);
    } catch (error) {
      console.error('Failed to fetch physicians: ', error);
    }
    if (current !== requestId) {
      return;
    }
    set({ physicians: [...physicians] });
  },
}));

export default usePhysicianStore;
